export default {
    // 路由国际化
    route: {
        dashboard: "Dashboard",
        document: "Document",
        Home: 'Home',
        companyProfile: 'About Us',
        newsInformation: 'News',
        ProductCenter: 'Products and Services',
        ResourceLibrary: 'Resource Library Center',
        Pilot: 'Customer Service',
        Contact: 'Contact Us',
        talentRecruitment: 'Careers',
        noticesAndMap: 'Notices and Map',
    },
    // 登录页面国际化
    login: {
        title: "vue3-element-admin",
        username: "Username",
        password: "Password",
        login: "Login",
        code: "Verification Code",
        copyright: "",
        icp: "",
    },
    // 导航栏国际化
    navbar: {
        login: 'Login',
        logout: "Logout",
        en: 'English',
        zhCn: 'Simplified Chinese',
        language: 'Language',
    },
    home: {
        title1: 'Company Profile',
        title2: 'Important news',
        title2_more: 'More',
        title3: 'Company News',
        title3_more: 'More',
        title4: 'Partners',
        company: 'Company information',
        searchTips: 'Please enter the search keyword',
        searchBtn: 'Search',
        source: 'Source',
        abstract: 'Abstract',
        updateTime: 'UpdateTime',
    },
    companyProfile: {
        companyProfile: 'Company Profile',
        companyStructure: 'Company Structure',
        corporateCulture: 'Corporate Culture',
        corporateHonor: 'Corporate Honors',
        development: 'Development',
        customers: 'Customers',
        partners: 'Partners',
        chinaSouthernAirlines: 'China Southern Airlines',
    },
    news: {
        companyNews: 'Company News',
        allNews: 'More',
        industryNews: 'Industry News',
        allIndustryNews: 'More',
        informationDisclosure: 'Information Disclosure',
        newsDetail: 'News Detail',
        dynamicDetail: 'Dynamic Detail',
        informationDetail: 'Information Detail',
        detail: 'Detail',
        year: 'Year',
        selectYear: 'Select Year',
    },
    productCenter: {
        productDetail: 'Product Detail',
        viewNow: 'Read more',
    },
    resource: {
        type: 'Type',
        format: 'Format',
        date: 'Date',
        startDate: 'Start date',
        endDate: 'End date',
        to: 'to',
        reading: 'Reading',
        down: 'Downloads',
        abstract: 'Abstract',
    },
    pilotService: {
        planQuery: "Plan Query",
        simulatorPlan: 'Simulator Training schedule',
        TheoreticalPlan: "Ground Training schedule",
        simulator: 'Simulator Training schedule',
        Theoretical: "Ground Training schedule",
        PilotTrafficGuidance: "Pilot Traffic Guidance",
        SelfServicePrinting: "Self Service Printing",
        Training: "Training Notes",
        LostAndFound: "Lost And Found",
        OtherDataQuery: "Other Data Query",
        QuestionnaireInvestigation: "Questionnaire",
        questionnaireDetails: "Questionnaire Details",
        OnlineLearningSystem: 'Online Learning',
        planTable: {
            applicationDate: 'ApplicationDate',
            serialNumber: 'Index',
            date: 'Date',
            time: 'Time',
            equipment: 'Equipment',
            trainingNature: 'TrainingNature',
            teacher: 'Teacher',
            student: 'Student',
            position: 'Position',
        }
    },
    contactUs: {
        contactInformation: 'Contacts',
        talentRecruitment: 'Careers',
        positionDetails: 'Position Detail',
        chinaSouthernAirlinesGroup: 'China Southern Airlines Group',
        contactInfo: {
            address: 'Address',
            postalCode: 'Postal Code',
            phone: 'Tel',
            feedback: 'Feedback',
            consultation: 'Consultation'
        },
        recruitmentTable: {
            jobTitle: 'Job Title',
            department: 'Department',
            recruitmentCategory: 'Recruitment Category',
            workingLocation: 'Working Location',
            releaseTime: 'ReleaseTime',
            jobDescription: 'Job Description',
            qualification: 'Qualification',
            HRContactInformation: 'HR Contact Information',
            chooseDepartment: 'Department',
            chooseCategory: 'Recruitment Category',
            chooseLocation: 'Work Location',
            choosePosition: 'Job Title',
        }
    },
    legalAndMap: {
        legalStatement: 'Legal Notices',
        siteMap: 'Site Map'
    },
    login: {
        login: 'Login',
        SMSLOGIN: 'SMS LOGIN',
        mobileNumber: 'Mobile Number',
        SMSCode: 'SMS Code',
        SEND: 'Send',
        captchaCode: 'Captcha Code'
    },
    footer: {
        officialWeChat: 'Official WeChat',
        officialVideo: 'WeChat Channels',
        officialTiktok: 'Official Tiktok',
        companyName: 'Copyright (c) Zhuhai Xiangyi Aviation Technology Co., Ltd. All Rights Reserved',
    }
};